<template>
  <div>
    <div class="mb-5">
      <h1 class="is-size-4">{{ flightDetails.departingAirport }} - {{ flightDetails.arrivingAirport }}</h1>
      <h2 class="is-size-6 has-text-grey">Flight #{{ flightDetails.marketingAirline }}{{ flightDetails.flightNumber }}</h2>
      <h3 class="is-size-6 has-text-grey">Departing {{ flightDetails.departingAt.date | formatDate }}</h3>
      <p></p>
    </div>

  </div>
</template>

<script>
//import Seat from './Seat.vue'
export default {
  components: {
    //Seat
  },
  methods: {
  },
  props: {
    flightDetails: Object,
  }
}

</script>

<style scoped>


</style>
